/**
 * The engine checkout session the app's native checkout runs on (LIS-975):
 * what `accesses.createCheckout` answers for an engine-backed event, and what
 * is read off it. The hosted page's `url` names both the checkout's origin
 * (where the card island's page lives) and the organizer slug the core
 * checks the session against; the client secret names the session.
 */
export type EngineCheckoutSession = {
  accessId: string;
  /** The hosted checkout page, e.g. `https://tickets.lissen.com/checkout/lissen`. */
  url: string;
  clientSecret: string;
  /** The engine's public API, which the client secret opens to its buyer. */
  apiBaseUrl: string;
  /** When the fan pressed Continue and when the session came back, as
   *  wall-clock milliseconds: the web checkout times its load from the press. */
  timing?: { requestedAt: number; sessionAt: number };
};

/** The checkout's origin: where `/checkout/card` is served. */
export const checkoutOriginOf = (url: string) => new URL(url).origin;

/** The organizer slug in `/checkout/{slug}`. */
export function checkoutSlugOf(url: string): string {
  const [, first, slug] = new URL(url).pathname.split("/");
  if (first !== "checkout" || !slug) throw new Error("not_a_checkout_url");
  return decodeURIComponent(slug);
}

/** `cs_…` out of `cs_…_secret_…`. */
export function checkoutSessionIdOf(clientSecret: string): string {
  const at = clientSecret.indexOf("_secret_");
  if (at <= 0) throw new Error("not_a_client_secret");
  return clientSecret.slice(0, at);
}
